<template>
  <v-container fluid class="pa-4">
    <!-- KPI Cards Compactos -->
    <v-row class="mb-4" dense>
      <v-col
        v-for="(kpi, index) in kpis"
        :key="index"
        cols="12"
        sm="6"
        md="4"
        lg="3"
        xl="2"
        class="px-2"
      >
        <v-card class="kpi-card elevation-0" outlined>
          <v-card-text class="pa-3">
            <div class="d-flex align-center">
              <div class="flex-grow-1">
                <div class="kpi-label">{{ kpi.label }}</div>
                <div class="kpi-value">{{ kpi.value }}</div>
                <div class="kpi-subtitle">{{ kpi.subtitle }}</div>
              </div>
              <v-icon :color="kpi.color" size="24">{{ kpi.icon }}</v-icon>
            </div>
          </v-card-text>
        </v-card>
      </v-col>
    </v-row>

    <!-- Card Principal Compacto -->
    <v-card class="main-card elevation-0" outlined>
      <!-- Header Minimizado -->
      <v-toolbar flat dense class="px-4">
        <h3 class="section-title">Inventario</h3>
        <v-spacer></v-spacer>

        <!-- Botones de Acción Compactos -->
        <v-btn-toggle v-model="activeAction" dense class="mr-3">
          <v-tooltip bottom>
            <template v-slot:activator="{ on, attrs }">
              <v-btn icon small v-bind="attrs" v-on="on" @click="handlePrintLabels">
                <v-icon small>mdi-printer</v-icon>
              </v-btn>
            </template>
            <span>Imprimir Etiquetas</span>
          </v-tooltip>

          <v-tooltip bottom>
            <template v-slot:activator="{ on, attrs }">
              <v-btn icon small v-bind="attrs" v-on="on" @click="edit_price = true">
                <v-icon small>mdi-currency-usd</v-icon>
              </v-btn>
            </template>
            <span>Cambiar Precio</span>
          </v-tooltip>

          <v-tooltip bottom>
            <template v-slot:activator="{ on, attrs }">
              <v-btn icon small v-bind="attrs" v-on="on" @click="edit_discount = true">
                <v-icon small>mdi-sale</v-icon>
              </v-btn>
            </template>
            <span>Aplicar Descuento</span>
          </v-tooltip>

          <v-tooltip bottom>
            <template v-slot:activator="{ on, attrs }">
              <v-btn
                icon
                small
                v-bind="attrs"
                v-on="on"
                @click="price_changes_lst = true"
              >
                <v-icon small>mdi-chart-line</v-icon>
              </v-btn>
            </template>
            <span>Ver Reportes</span>
          </v-tooltip>
        </v-btn-toggle>

        <v-menu offset-y>
          <template v-slot:activator="{ on, attrs }">
            <v-btn icon v-bind="attrs" v-on="on">
              <v-icon>mdi-dots-vertical</v-icon>
            </v-btn>
          </template>
          <v-list dense>
            <v-list-item @click="exportJSONToCSV(inventory_filter)">
              <v-list-item-icon>
                <v-icon>mdi-download</v-icon>
              </v-list-item-icon>
              <v-list-item-content>
                <v-list-item-title>Exportar CSV</v-list-item-title>
              </v-list-item-content>
            </v-list-item>
            <v-list-item @click="reloadInventory">
              <v-list-item-icon>
                <v-icon>mdi-refresh</v-icon>
              </v-list-item-icon>
              <v-list-item-content>
                <v-list-item-title>Actualizar</v-list-item-title>
              </v-list-item-content>
            </v-list-item>
          </v-list>
        </v-menu>
      </v-toolbar>

      <!-- Filtros Colapsables -->
      <v-expansion-panels flat>
        <v-expansion-panel>
          <v-expansion-panel-header class="pa-4">
            <span>
              <v-icon left>mdi-filter</v-icon>
              Filtros {{ hasActiveFilters ? `(${activeFiltersCount})` : "" }}
            </span>
          </v-expansion-panel-header>

          <v-expansion-panel-content>
            <v-row dense>
              <v-col cols="12" md="4">
                <v-text-field
                  v-model="filters.nombre"
                  label="Buscar producto"
                  prepend-inner-icon="mdi-magnify"
                  clearable
                  outlined
                  dense
                  hide-details
                  @input="onSearchInput"
                />
              </v-col>
              <v-col cols="6" md="2">
                <v-select
                  v-model="filters.categoria"
                  :items="categories"
                  label="Categoría"
                  item-value="valor"
                  item-text="valor"
                  outlined
                  dense
                  hide-details
                  clearable
                  @change="filterData"
                />
              </v-col>
              <v-col cols="6" md="2">
                <v-autocomplete
                  v-model="filters.marca"
                  :items="brands"
                  label="Marca"
                  item-value="valor"
                  item-text="valor"
                  outlined
                  dense
                  hide-details
                  clearable
                  @change="filterData"
                />
              </v-col>
              <v-col cols="6" md="2">
                <v-text-field
                  v-model="filters.refe"
                  label="Referencia"
                  clearable
                  outlined
                  dense
                  hide-details
                  @input="onSearchInput"
                />
              </v-col>
              <v-col cols="6" md="2">
                <v-autocomplete
                  v-model="filters.id_proveedor"
                  :items="suppliers"
                  label="Proveedor"
                  item-value="codigo"
                  item-text="nombre"
                  outlined
                  dense
                  hide-details
                  clearable
                  @change="filterData"
                />
              </v-col>
              <v-col cols="6" md="2">
                <v-text-field
                  v-model="filters.precio"
                  label="Precio"
                  type="number"
                  clearable
                  outlined
                  dense
                  hide-details
                  @input="onSearchInput"
                />
              </v-col>
              <v-col cols="6" md="2">
                <v-switch
                  v-model="includeZeroStock"
                  label="Sin stock"
                  color="primary"
                  @change="reloadInventory"
                  dense
                  hide-details
                ></v-switch>
              </v-col>
            </v-row>
            <v-row dense class="mt-2">
              <v-col cols="12" class="text-right">
                <v-btn
                  small
                  outlined
                  color="primary"
                  :disabled="!hasActiveFilters"
                  @click="clearFilters"
                >
                  <v-icon left small>mdi-filter-remove</v-icon>
                  Limpiar Filtros
                </v-btn>
              </v-col>
            </v-row>
          </v-expansion-panel-content>
        </v-expansion-panel>
      </v-expansion-panels>

      <!-- Tabla Compacta -->
      <v-data-table
        v-model="selected"
        show-select
        :headers="compactHeaders"
        :items="inventory_filter"
        :items-per-page="20"
        item-key="ean"
        :loading="loading_status"
        class="compact-table"
        dense
        :footer-props="{
          'items-per-page-options': [20, 50, 100],
          'show-current-page': true,
          'show-first-last-page': true,
        }"
      >
        <!-- Nombre del Producto -->

        <!-- Costo -->
        <template v-slot:item.costo="{ item }">
          <div class="cost-cell text-right">
            <div class="cost-main">{{ formatCurrency(item.costo) }}</div>
          </div>
        </template>

        <!-- Precio con Descuento -->
        <template v-slot:item.precio="{ item }">
          <div class="price-cell">
            <div class="price-main">{{ formatCurrency(item.precio) }}</div>
            <v-chip
              v-if="item.descuento > 0"
              x-small
              color="success"
              text-color="white"
              class="discount-chip"
            >
              -{{ formatNumber(item.descuento) }}%
            </v-chip>
          </div>
        </template>

        <!-- Stock Compacto -->
        <template v-slot:item.cantidad="{ item }">
          <v-chip
            x-small
            :color="getStockColor(item.cantidad)"
            text-color="white"
            class="stock-chip"
          >
            {{ formatNumber(item.cantidad) }}
          </v-chip>
        </template>

        <!-- Valor Total -->
        <template v-slot:item.valor_total="{ item }">
          <div class="text-right font-weight-medium">
            {{ formatCurrency(getItemTotalValue(item)) }}
          </div>
        </template>

        <!-- Acciones Compactas -->
        <template v-slot:item.actions="{ item }">
          <v-btn icon x-small @click="editItem(item)">
            <v-icon x-small>mdi-camera</v-icon>
          </v-btn>
        </template>
      </v-data-table>

      <!-- Resumen Inferior -->
      <v-card-actions class="px-4 py-2 grey lighten-5">
        <div class="d-flex align-center w-100">
          <span class="text-caption">
            {{ selected.length }} seleccionados de {{ inventory_filter.length }} productos
          </span>
          <v-spacer></v-spacer>
          <span class="text-caption font-weight-medium">
            Total mostrado: ${{ formatCurrency(totalVisible) }}
          </span>
        </div>
      </v-card-actions>
    </v-card>

    <!-- Item Dialog (Image Upload) -->
    <v-dialog v-model="item_dialogo" max-width="500px">
      <v-card class="elevation-0">
        <v-card-title class="headline pa-6">
          Imagen del Producto
          <v-spacer></v-spacer>
          <v-btn icon @click="item_dialogo = false">
            <v-icon>mdi-close</v-icon>
          </v-btn>
        </v-card-title>

        <v-hover>
          <template v-slot:default="{ hover }">
            <v-card flat>
              <v-img
                cover
                aspect-ratio="1"
                class="grey lighten-4"
                :src="getImageURL(itemEdit.marca, itemEdit.refe)"
                height="400"
              >
                <template v-slot:placeholder>
                  <v-row class="fill-height ma-0" align="center" justify="center">
                    <v-progress-circular indeterminate color="grey lighten-5" />
                  </v-row>
                </template>
              </v-img>
              <input
                class="file-input"
                ref="fileInput"
                type="file"
                accept="image/*"
                @input="onSelectFile(itemEdit)"
              />
              <v-fade-transition>
                <v-overlay v-if="hover" absolute>
                  <v-btn color="primary" @click="chooseImage">
                    <v-icon left>mdi-cloud-upload</v-icon>
                    Subir Imagen
                  </v-btn>
                </v-overlay>
              </v-fade-transition>
            </v-card>
          </template>
        </v-hover>
      </v-card>
    </v-dialog>

    <!-- Price Change Dialog -->
    <v-dialog v-model="edit_price" max-width="400px">
      <v-form v-model="price_valid" ref="priceChangeform" @submit="price_change">
        <v-card class="elevation-0">
          <v-card-title class="headline pa-6">
            Cambio de Precio
            <v-spacer></v-spacer>
            <v-btn icon @click="edit_price = false">
              <v-icon>mdi-close</v-icon>
            </v-btn>
          </v-card-title>

          <v-card-text v-if="selected.length === 0" class="text-center py-8">
            <v-icon size="64" color="grey lighten-2">mdi-alert-circle-outline</v-icon>
            <p class="mt-4 grey--text">Selecciona los productos para cambiar el precio</p>
          </v-card-text>

          <v-card-text v-else>
            <div class="text-center mb-6">
              <v-chip color="primary" text-color="white" class="px-6">
                {{ selected.length }} productos seleccionados
              </v-chip>
            </div>

            <v-text-field
              v-model="newPrice"
              label="Nuevo precio"
              prefix="$"
              type="number"
              outlined
              autofocus
              :rules="f_required"
              class="centered-input"
            />
          </v-card-text>

          <v-card-actions v-if="selected.length !== 0" class="pa-6">
            <v-spacer></v-spacer>
            <v-btn text @click="edit_price = false">Cancelar</v-btn>
            <v-btn
              color="primary"
              type="submit"
              :disabled="!price_valid"
              :loading="loading_price_change"
            >
              Aplicar Cambio
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-form>
    </v-dialog>

    <!-- Discount Dialog -->
    <v-dialog v-model="edit_discount" max-width="400px">
      <v-form v-model="discount_valid" ref="discountChangeform" @submit="discount_change">
        <v-card class="elevation-0">
          <v-card-title class="headline pa-6">
            Aplicar Descuento
            <v-spacer></v-spacer>
            <v-btn icon @click="edit_discount = false">
              <v-icon>mdi-close</v-icon>
            </v-btn>
          </v-card-title>

          <v-card-text v-if="selected.length === 0" class="text-center py-8">
            <v-icon size="64" color="grey lighten-2">mdi-alert-circle-outline</v-icon>
            <p class="mt-4 grey--text">Selecciona los productos para aplicar descuento</p>
          </v-card-text>

          <v-card-text v-else>
            <div class="text-center mb-6">
              <v-chip color="success" text-color="white" class="px-6">
                {{ selected.length }} productos seleccionados
              </v-chip>
            </div>

            <v-text-field
              v-model="newDiscount"
              label="Porcentaje de descuento"
              suffix="%"
              type="number"
              outlined
              autofocus
              :rules="f_required"
              class="centered-input"
            />
          </v-card-text>

          <v-card-actions v-if="selected.length !== 0" class="pa-6">
            <v-spacer></v-spacer>
            <v-btn text @click="edit_discount = false">Cancelar</v-btn>
            <v-btn
              color="success"
              type="submit"
              :disabled="!discount_valid"
              :loading="loading_discount_change"
            >
              Aplicar Descuento
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-form>
    </v-dialog>

    <!-- Price Changes Report Dialog -->
    <v-dialog
      v-model="price_changes_lst"
      fullscreen
      transition="dialog-bottom-transition"
    >
      <v-card class="elevation-0">
        <v-toolbar flat class="minimal-toolbar">
          <h2 class="section-title">Reporte de Cambios de Precio</h2>
          <v-spacer></v-spacer>
          <v-btn icon @click="price_changes_lst = false">
            <v-icon>mdi-close</v-icon>
          </v-btn>
        </v-toolbar>

        <v-card-text class="pa-6">
          <!-- Report KPIs -->
          <v-row class="mb-6" dense>
            <v-col cols="12" sm="4">
              <v-card class="kpi-card elevation-0" outlined>
                <v-card-text class="pa-3">
                  <div class="kpi-label">Cambios Realizados Hoy</div>
                  <div class="kpi-value">{{ changes_lst.length }}</div>
                </v-card-text>
              </v-card>
            </v-col>
            <v-col cols="12" sm="4">
              <v-card class="kpi-card elevation-0" outlined>
                <v-card-text class="pa-3">
                  <div class="kpi-label">Productos Afectados</div>
                  <div class="kpi-value">{{ totalAffectedProducts }}</div>
                </v-card-text>
              </v-card>
            </v-col>
            <v-col cols="12" sm="4">
              <v-card class="kpi-card elevation-0" outlined>
                <v-card-text class="pa-3">
                  <div class="kpi-label">Valor Promedio Cambio</div>
                  <div class="kpi-value">{{ formatCurrency(averageChangeValue) }}</div>
                </v-card-text>
              </v-card>
            </v-col>
          </v-row>

          <v-data-table
            :headers="minimalChangeHeaders"
            :items="changes_lst"
            :items-per-page="10"
            class="minimal-table elevation-1"
            :loading="loading_changes"
          >
            <template v-slot:item.diferencia="{ item }">
              <v-chip
                small
                :color="item.diferencia > 0 ? 'success' : 'error'"
                text-color="white"
              >
                {{ item.diferencia > 0 ? "+" : "" }}${{ formatNumber(item.diferencia) }}
              </v-chip>
            </template>
          </v-data-table>
        </v-card-text>
      </v-card>
    </v-dialog>

    <!-- Snackbar for notifications -->
    <v-snackbar
      v-model="snackbar.show"
      :color="snackbar.color"
      :timeout="snackbar.timeout"
      bottom
    >
      {{ snackbar.text }}
      <template v-slot:action="{ attrs }">
        <v-btn text v-bind="attrs" @click="snackbar.show = false"> Cerrar </v-btn>
      </template>
    </v-snackbar>
    <label-printer
      v-model="showLabelPrinter"
      :items="selected"
      @labels-printed="onLabelsPrinted"
      @show-notification="showNotification"
    />
  </v-container>
</template>

<script>
import { compressAndUploadProductPhoto } from "@/utils/uploadProductPhoto.js";
import {
  webserver,
  getToday,
  formatCurrency,
  formatNumber,
} from "@/services/webserver.js";
import LabelPrinter from "@/components/LabelPrinter.vue";
import createItem from "@/utils/createItem.js";

export default {
  name: "InventoryComponent",
  components: { LabelPrinter },
  data() {
    return {
      // Original data properties
      showLabelPrinter: false,
      errors: [],
      valid: false,
      item_dialogo: false,
      edit_price: false,
      edit_discount: false,
      price_valid: false,
      discount_valid: false,
      newPrice: 0,
      newDiscount: 0,
      loading_status: false,
      loading_price_change: false,
      loading_discount_change: false,
      f_required: [(v) => !!v || "Requerido"],
      imageUrl: null,
      dialog: false,
      selected: [],
      brands: [],
      categories: [],
      filters: {
        nombre: "",
        categoria: null,
        marca: null,
        refe: "",
        precio: null,
        id_proveedor: null,
      },
      suppliers: [],
      search: "",
      itemEdit: createItem(),
      compressed_image: null,
      inventory_lst: [],
      inventory_filter: [],
      includeZeroStock: false,
      item: createItem(),
      changes_lst: [],
      price_changes_lst: false,
      loading_changes: false,
      activeAction: null,
      searchTimeout: null,
      snackbar: {
        show: false,
        text: "",
        color: "success",
        timeout: 3000,
      },

      // Headers compactos
      compactHeaders: [
        {
          text: "Producto",
          value: "nombre",

          sortable: true,
        },
        {
          text: "Categoría",
          value: "category",
        },
        {
          text: "Grupo",
          value: "grupName",
        },
        {
          text: "Marca",
          value: "brand",
        },
        {
          text: "Color",
          value: "colorName",
        },
        {
          text: "Tamaño",
          value: "talla",
        },
        {
          text: "Costo",
          value: "costo",
          align: "end",
        },
        {
          text: "Precio",
          value: "precio",
          align: "end",
        },
        {
          text: "Stock",
          value: "cantidad",
          align: "center",
        },
        {
          text: "Valor Total",
          value: "valor_total",
          align: "end",
        },
      ],

      minimalChangeHeaders: [
        {
          text: "Producto",
          value: "refe",
        },
        {
          text: "Categoría",
          value: "categoria",
        },
        {
          text: "Cantidad",
          value: "quantity",
          align: "center",
        },
        {
          text: "Precio Anterior",
          value: "price",
          align: "end",
        },
        {
          text: "Precio Nuevo",
          value: "newPrice",
          align: "end",
        },
        {
          text: "Diferencia",
          value: "diferencia",
          align: "center",
        },
      ],
    };
  },

  computed: {
    // KPIs Validados y Optimizados
    kpis() {
      return [
        {
          key: "cost",
          label: "Costo Total",
          value: this.formatCurrency(this.totalInventoryCostAmount),
          subtitle: `${this.formatNumber(this.totalProductsCount)} productos`,
          icon: "mdi-currency-usd",
          color: "success",
        },
        {
          key: "price",
          label: "Precio Total",
          value: this.formatCurrency(this.totalInventoryValueAmount),
          subtitle: `Margen: ${this.formatCurrency(this.totalInventoryMarginAmount)}`,
          icon: "mdi-tag-multiple",
          color: "info",
        },
        {
          key: "stock",
          label: "Stock Total",
          value: this.formatNumber(this.totalItemsCount),
          subtitle: this.hasActiveFilters
            ? `${this.formatNumber(
                this.totalProductsCount
              )} productos (${this.formatNumber(
                this.totalUniqueProductsCount
              )} referencias)`
            : `${this.formatNumber(
                this.totalProductsCount
              )} productos (${this.formatNumber(
                this.totalUniqueProductsCount
              )} referencias)`,
          icon: "mdi-cube-outline",
          color: "primary",
        },
        {
          key: "alerts",
          label: "Alertas Stock",
          value: this.formatNumber(this.lowStockCount),
          subtitle:
            this.outOfStockCount > 0
              ? `${this.formatNumber(this.outOfStockCount)} agotados`
              : "Stock normal",
          icon: this.outOfStockCount > 0 ? "mdi-alert" : "mdi-check-circle",
          color: this.outOfStockCount > 0 ? "error" : "success",
        },
      ];
    },

    discountPercentageValue() {
      if (this.inventory_filter.length === 0) return 0;
      return Math.round(
        (this.productsWithDiscountCount / this.inventory_filter.length) * 100
      );
    },

    lowStockCount() {
      if (!Array.isArray(this.inventory_filter)) return 0;
      return this.inventory_filter.filter((item) => {
        const cantidad = Number(item.cantidad) || 0;
        return cantidad < 10 && cantidad > 0;
      }).length;
    },

    outOfStockCount() {
      if (!Array.isArray(this.inventory_filter)) return 0;
      return this.inventory_filter.filter((item) => {
        const cantidad = Number(item.cantidad) || 0;
        return cantidad === 0;
      }).length;
    },

    totalAffectedProductsCount() {
      if (!Array.isArray(this.changes_lst)) return 0;
      return this.changes_lst.reduce((sum, item) => {
        const quantity = Number(item.quantity) || 0;
        return sum + quantity;
      }, 0);
    },

    averageChangeValueAmount() {
      if (!Array.isArray(this.changes_lst) || this.changes_lst.length === 0) return 0;
      const avg =
        this.changes_lst.reduce((sum, item) => {
          const diferencia = Number(item.diferencia) || 0;
          return sum + Math.abs(diferencia);
        }, 0) / this.changes_lst.length;
      return avg;
    },

    totalVisibleAmount() {
      if (!Array.isArray(this.inventory_filter)) return 0;
      return this.inventory_filter.reduce((sum, item) => {
        return sum + this.getItemTotalValue(item);
      }, 0);
    },

    totalProductsCount() {
      if (!Array.isArray(this.inventory_filter)) return 0;
      return this.inventory_filter.length;
    },

    totalUniqueProductsCount() {
      if (!Array.isArray(this.inventory_filter)) return 0;
      const uniqueRefs = new Set(
        this.inventory_filter.filter((item) => item.refe).map((item) => item.refe)
      );
      return uniqueRefs.size;
    },

    totalItemsCount() {
      if (!Array.isArray(this.inventory_filter)) return 0;
      return this.inventory_filter.reduce((sum, item) => {
        const cantidad = Number(item.cantidad) || 0;
        return sum + cantidad;
      }, 0);
    },

    totalInventoryItemsCount() {
      // Total de unidades en el inventario completo (sin filtros)
      if (!Array.isArray(this.inventory_lst)) return 0;
      return this.inventory_lst.reduce((sum, item) => {
        const cantidad = Number(item.cantidad) || 0;
        return sum + cantidad;
      }, 0);
    },

    totalInventoryValueAmount() {
      if (!Array.isArray(this.inventory_filter)) return 0;
      return this.inventory_filter.reduce((sum, item) => {
        const precio = Number(item.precio) || 0;
        const cantidad = Number(item.cantidad) || 0;
        return sum + precio * cantidad;
      }, 0);
    },

    totalInventoryCostAmount() {
      if (!Array.isArray(this.inventory_filter)) return 0;
      return this.inventory_filter.reduce((sum, item) => {
        const costo = Number(item.costo) || 0;
        const cantidad = Number(item.cantidad) || 0;
        return sum + costo * cantidad;
      }, 0);
    },

    totalInventoryMarginAmount() {
      return this.totalInventoryValueAmount - this.totalInventoryCostAmount;
    },

    productsWithDiscountCount() {
      if (!Array.isArray(this.inventory_filter)) return 0;
      return this.inventory_filter.filter((item) => {
        const descuento = Number(item.descuento) || 0;
        return descuento > 0;
      }).length;
    },

    // KPIs Validados con verificación de datos
    totalProducts() {
      if (!Array.isArray(this.inventory_filter)) return 0;
      return this.inventory_filter.length; // Número 1234
    },

    totalUniqueProducts() {
      if (!Array.isArray(this.inventory_filter)) return 0;
      const uniqueRefs = new Set(
        this.inventory_filter
          .filter((item) => item.refe) // Validar que existe la referencia
          .map((item) => item.refe)
      );
      return uniqueRefs.size;
    },

    totalItems() {
      if (!Array.isArray(this.inventory_filter)) return 0;
      const total = this.inventory_filter.reduce((sum, item) => {
        const cantidad = Number(item.cantidad) || 0;
        return sum + cantidad;
      }, 0);
      return this.formatNumber(total);
    },

    totalInventoryValue() {
      if (!Array.isArray(this.inventory_filter)) return 0;
      const total = this.inventory_filter.reduce((sum, item) => {
        const precio = Number(item.precio) || 0;
        const cantidad = Number(item.cantidad) || 0;
        return sum + precio * cantidad;
      }, 0);
      return this.formatNumber(Math.round(total));
    },

    productsWithDiscount() {
      if (!Array.isArray(this.inventory_filter)) return 0;
      return this.inventory_filter.filter((item) => {
        const descuento = Number(item.descuento) || 0;
        return descuento > 0;
      }).length;
    },

    discountPercentage() {
      if (this.inventory_filter.length === 0) return 0;
      return Math.round((this.productsWithDiscount / this.inventory_filter.length) * 100);
    },

    criticalStockCount() {
      if (!Array.isArray(this.inventory_filter)) return 0;
      return this.inventory_filter.filter((item) => {
        const cantidad = Number(item.cantidad) || 0;
        return cantidad < 5 && cantidad > 0;
      }).length;
    },

    hasActiveFilters() {
      return Object.values(this.filters).some((val) => val !== null && val !== "");
    },

    activeFiltersCount() {
      return Object.values(this.filters).filter((val) => val !== null && val !== "")
        .length;
    },

    totalVisible() {
      if (!Array.isArray(this.inventory_filter)) return 0;
      return this.inventory_filter.reduce((sum, item) => {
        return sum + this.getItemTotalValue(item);
      }, 0);
    },

    // Price changes report calculations
    totalAffectedProducts() {
      if (!Array.isArray(this.changes_lst)) return 0;
      const total = this.changes_lst.reduce((sum, item) => {
        const quantity = Number(item.quantity) || 0;
        return sum + quantity;
      }, 0);
      return this.formatNumber(total);
    },

    averageChangeValue() {
      if (!Array.isArray(this.changes_lst) || this.changes_lst.length === 0) return 0;
      const avg =
        this.changes_lst.reduce((sum, item) => {
          const diferencia = Number(item.diferencia) || 0;
          return sum + Math.abs(diferencia);
        }, 0) / this.changes_lst.length;
      return this.formatNumber(Math.round(avg));
    },
  },

  mounted() {
    this.get_inventory();
    this.initializeCategories();
    this.initializeBrands();
    this.get_suppliers();
  },

  beforeDestroy() {
    // Limpiar timeout si existe
    if (this.searchTimeout) {
      clearTimeout(this.searchTimeout);
    }
  },

  methods: {
    formatCurrency,
    formatNumber,
    // Initialize data
    initializeCategories() {
      this.categories = Array.isArray(window.settings["CATEGORIA"])
        ? window.settings["CATEGORIA"].sort(this.GetSortOrder("valor"))
        : [];
    },

    initializeBrands() {
      this.brands = Array.isArray(window.settings["MARCA"])
        ? window.settings["MARCA"].sort(this.GetSortOrder("valor"))
        : [];
    },

    get_suppliers() {
      const qry = {
        store: window.store.store_id,
        table: "proveedores",
        filters: [
          {
            field: "store",
            operator: "=",
            value: window.store.store_id.substring(0, 6),
          },
        ],
      };
      webserver(
        "get_dataTable",
        qry,
        (data) => {
          this.suppliers = Array.isArray(data) ? data : [];
        },
        () => {
          this.suppliers = [];
        }
      );
    },

    // Debounce implementation without lodash
    onSearchInput() {
      if (this.searchTimeout) {
        clearTimeout(this.searchTimeout);
      }
      this.searchTimeout = setTimeout(() => {
        this.filterData();
      }, 300);
    },

    // Data fetching
    get_inventory() {
      this.loading_status = true;
      const filters = [
        {
          field: "id_pos",
          operator: "=",
          value: window.store.store_id,
        },
      ];

      // Solo agregar filtro de cantidad > 0 si no se quieren incluir productos sin stock
      if (!this.includeZeroStock) {
        filters.push({
          field: "cantidad",
          operator: ">",
          value: 0,
        });
      }

      const qry = {
        store: window.store.store_id,
        table: "items",
        filters: filters,
      };

      webserver("get_catalog", qry, (data) => {
        console.log("Inventory data received:", data);
        this.loading_status = false;

        if (Array.isArray(data)) {
          this.inventory_lst = data;
          this.inventory_filter = data;
        } else {
          console.error("Invalid inventory data received:", data);
          this.inventory_lst = [];
          this.inventory_filter = [];
          this.showNotification("Error al cargar inventario", "error");
        }
      });
    },

    get_changes() {
      this.loading_changes = true;
      const qry = {
        store: window.store.store_id,
        issueDate: getToday(),
      };

      webserver("get_inventory_pc", qry, (data) => {
        console.log("Changes data received:", data);
        this.loading_changes = false;

        if (Array.isArray(data)) {
          data.forEach((itm) => {
            itm.diferencia = parseFloat(itm.diferencia) || 0;
            itm.price = parseFloat(itm.price) || 0;
            itm.quantity = parseFloat(itm.quantity) || 0;
            itm.newPrice = parseFloat(itm.newPrice) || 0;
          });
          this.changes_lst = data;
        } else {
          this.changes_lst = [];
        }
      });
    },

    // Utility methods
    GetSortOrder(prop) {
      return function (a, b) {
        if (a[prop] > b[prop]) {
          return 1;
        } else if (a[prop] < b[prop]) {
          return -1;
        }
        return 0;
      };
    },

    getItemTotalValue(item) {
      const precio = Number(item.precio) || 0;
      const cantidad = Number(item.cantidad) || 0;
      return precio * cantidad;
    },

    getItemTotalCost(item) {
      const costo = Number(item.costo) || 0;
      const cantidad = Number(item.cantidad) || 0;
      return costo * cantidad;
    },

    getItemMargin(item) {
      return this.getItemTotalValue(item) - this.getItemTotalCost(item);
    },

    getStockColor(quantity) {
      const qty = Number(quantity) || 0;
      if (qty === 0) return "error";
      if (qty < 10) return "warning";
      return "success";
    },

    getImageURL(marca, refe) {
      if (!marca || !refe) return "";
      const account = window.store.store_id.substring(0, 6);
      let url = `https://moda-stc.com/photos/${account}/${marca}/${refe}.jpg`;
      if (this.compressed_image) url = this.compressed_image;
      return url;
    },

    // Filtering
    filterData() {
      const filter = this.filters;
      this.inventory_filter = this.inventory_lst.filter((item) => {
        for (const key in filter) {
          if (filter[key] !== null && filter[key] !== "") {
            if (
              item[key] === undefined ||
              !item[key]
                .toString()
                .toLowerCase()
                .includes(filter[key].toString().toLowerCase())
            ) {
              return false;
            }
          }
        }
        return true;
      });
    },

    clearFilters() {
      this.filters = {
        nombre: "",
        categoria: null,
        marca: null,
        refe: "",
        precio: null,
        id_proveedor: null,
      };
      this.filterData();
    },

    // Actions
    editItem(data) {
      this.itemEdit = { ...data };
      this.item_dialogo = true;
    },

    reloadInventory() {
      this.get_inventory();
      this.showNotification("Inventario actualizado", "success");
    },

    handlePrintLabels() {
      if (this.selected.length === 0) {
        this.showNotification("Selecciona productos para imprimir etiquetas", "warning");
        return;
      }
      this.showLabelPrinter = true;
    },
    onLabelsPrinted(data) {
      console.log("Etiquetas impresas:", data);
      this.selected = []; // Limpiar selección si deseas
    },

    // Image handling
    chooseImage() {
      this.$refs.fileInput.click();
    },

    async onSelectFile(dat) {
      const input = this.$refs.fileInput;
      const files = input && input.files;
      if (!files || !files[0]) return;

      const file = files[0];
      this.item.picture = file.name.toLowerCase();
      try {
        const result = await compressAndUploadProductPhoto({
          file,
          item: dat,
          store: window.store.store_id,
        });
        this.compressed_image = result.photoDataUrl;
        dat.picture = result.picture;
        this.showNotification("Imagen subida exitosamente", "success");
        // Limpiar preview en memoria; la URL real ya esta en moda-stc.com.
        this.compressed_image = null;
      } catch (err) {
        this.showNotification(
          "Error al subir la imagen: " + (err.message || err),
          "error"
        );
      }
    },

    // Export functionality
    exportJSONToCSV(objArray) {
      if (!Array.isArray(objArray) || objArray.length === 0) {
        this.showNotification("No hay datos para exportar", "warning");
        return;
      }

      const arr = objArray;
      let str =
        `${Object.keys(arr[0])
          .map((value) => `"${value}"`)
          .join(",")}` + "\r\n";

      const csvContent = arr.reduce((st, next) => {
        st +=
          `${Object.values(next)
            .map((value) => `"${value}"`)
            .join(",")}` + "\r\n";
        return st;
      }, str);

      const element = document.createElement("a");
      element.href = "data:text/csv;charset=utf-8," + encodeURI(csvContent);
      element.target = "_blank";

      const current = new Date();
      const cDate =
        current.getFullYear() + "-" + (current.getMonth() + 1) + "-" + current.getDate();
      const cTime =
        current.getHours() + ":" + current.getMinutes() + ":" + current.getSeconds();
      const fileName = cDate + "_" + cTime;

      element.download = fileName + ".csv";
      element.click();

      this.showNotification("Archivo CSV descargado", "success");
    },

    // Price and discount changes
    discount_change(e) {
      e.preventDefault();
      this.$refs.discountChangeform.validate();

      if (this.discount_valid && this.selected.length > 0) {
        this.loading_discount_change = true;

        const qry = {
          store: window.store.store_id,
          newprice: parseInt(this.newDiscount),
          products: this.selected,
          userId: window.userId,
        };

        if (qry.newprice > 0) {
          console.log("Applying discount:", qry);
          webserver("changeDiscount", qry, (response) => {
            console.log("Discount change response:", response);
            this.loading_discount_change = false;
            this.get_inventory();
            this.edit_discount = false;
            this.selected = [];
            this.newDiscount = 0;
            this.showNotification("Descuento aplicado exitosamente", "success");
          });
        } else {
          this.loading_discount_change = false;
          this.showNotification("El descuento debe ser mayor a 0", "error");
        }
      }
    },

    price_change(e) {
      e.preventDefault();
      this.$refs.priceChangeform.validate();

      if (this.price_valid && this.selected.length > 0) {
        this.loading_price_change = true;

        const qry = {
          store: window.store.store_id,
          newprice: parseInt(this.newPrice),
          products: this.selected,
          userId: window.userId,
        };

        if (qry.newprice > 0) {
          console.log("Changing price:", qry);
          webserver("changePrice", qry, (response) => {
            console.log("Price change response:", response);
            this.loading_price_change = false;
            this.get_inventory();
            this.edit_price = false;
            this.selected = [];
            this.newPrice = 0;
            this.showNotification("Precio cambiado exitosamente", "success");
          });
        } else {
          this.loading_price_change = false;
          this.showNotification("El precio debe ser mayor a 0", "error");
        }
      }
    },

    // Notifications
    showNotification(text, color = "success", timeout = 3000) {
      this.snackbar = {
        show: true,
        text: text,
        color: color,
        timeout: timeout,
      };
    },
  },

  watch: {
    price_changes_lst(visible) {
      if (visible) {
        console.log("Loading price changes report...");
        this.get_changes();
      }
    },

    selected(newVal) {
      console.log("Selected items:", newVal.length);
    },
  },
};
</script>

<style scoped>
/* Global Styles */
.file-input {
  display: none;
}

.centered-input >>> input {
  text-align: center;
}

/* KPI Cards Compactos */
.kpi-card {
  border: 1px solid #e0e0e0;
  transition: all 0.2s ease;
}

.kpi-card:hover {
  transform: translateY(-1px);
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1) !important;
}

.kpi-label {
  font-size: 0.75rem;
  color: #666;
  font-weight: 500;
  margin-bottom: 4px;
}

.kpi-value {
  font-size: 1.5rem;
  font-weight: 700;
  color: #333;
  line-height: 1.2;
}

.kpi-subtitle {
  font-size: 0.7rem;
  color: #999;
  margin-top: 2px;
}

/* Main Card */
.main-card {
  border: 1px solid #e0e0e0;
}

/* Toolbar and Headers */
.minimal-toolbar {
  border-bottom: 1px solid #e0e0e0;
  padding: 16px 24px;
}

.section-title {
  font-size: 1.25rem;
  font-weight: 600;
  color: #333;
}

/* Action Buttons */
.v-btn-toggle {
  border: 1px solid #e0e0e0 !important;
  border-radius: 8px !important;
}

.v-btn-toggle .v-btn {
  border: none !important;
  color: #666 !important;
}

.v-btn-toggle .v-btn:hover {
  background-color: #f5f5f5;
}

/* Tabla Compacta */
.compact-table >>> .v-data-table__wrapper {
  border: none;
}

.compact-table >>> thead tr th {
  background-color: #fafafa !important;
  font-weight: 600 !important;
  color: #666 !important;
  font-size: 0.8rem !important;
  padding: 8px 12px !important;
  height: 40px !important;
  border-bottom: 2px solid #e0e0e0 !important;
}

.compact-table >>> tbody tr td {
  padding: 8px 12px !important;
  font-size: 0.8rem !important;
  height: 48px !important;
  border-bottom: 1px solid #f0f0f0 !important;
}

.compact-table >>> tbody tr:hover {
  background-color: #fafafa !important;
}

/* Celdas de Producto */
.product-cell {
  max-width: 250px;
}

.product-name {
  font-weight: 500;
  color: #333;
  font-size: 0.8rem;
  line-height: 1.2;
  margin-bottom: 2px;
}

.product-meta {
  display: flex;
  align-items: center;
  gap: 4px;
}

.ref-text {
  font-size: 0.7rem;
  color: #666;
}

/* Costo */
.cost-cell {
  text-align: right;
}

.cost-main {
  font-weight: 500;
  color: #4caf50;
  font-size: 0.85rem;
}

/* Precio */
.price-cell {
  text-align: right;
}

.price-main {
  font-weight: 600;
  color: #333;
  font-size: 0.85rem;
}

.discount-chip {
  margin-top: 2px;
}

/* Stock */
.stock-chip {
  min-width: 40px;
  font-weight: 600;
  font-size: 0.7rem;
}

/* Dialogs */
.v-dialog .headline {
  font-size: 1.25rem !important;
  font-weight: 600;
  color: #333;
}

/* Loading */
.compact-table >>> .v-data-table__progress {
  height: 2px !important;
}

/* Expansion Panel */
.v-expansion-panel-header {
  min-height: 48px !important;
}

.v-expansion-panel-content >>> .v-expansion-panel-content__wrap {
  padding: 16px 24px 24px !important;
}

/* Responsive */
@media (max-width: 960px) {
  .kpi-value {
    font-size: 1.25rem;
  }

  .section-title {
    font-size: 1.1rem;
  }

  .compact-table >>> tbody tr td {
    padding: 6px 8px !important;
    font-size: 0.75rem !important;
  }

  .product-cell {
    max-width: 200px;
  }
}

@media (max-width: 600px) {
  .kpi-value {
    font-size: 1.1rem;
  }

  .compact-table >>> thead tr th {
    padding: 6px 4px !important;
    font-size: 0.7rem !important;
  }

  .compact-table >>> tbody tr td {
    padding: 4px !important;
    font-size: 0.7rem !important;
    height: 40px !important;
  }
}
</style>
